/**
 * useAccessControl.js
 * Entry-Code-System für Soft Launch
 *
 * Ohne gültigen Entry-Code: "Coming Soon" statt Login
 * Mit Entry-Code: Login möglich
 *
 * Beispiel-URLs:
 * - randalaise.com → Coming Soon
 * - randalaise.com?entry=friends → Login möglich
 */
import { useState, useEffect } from 'react';

// Gültige Entry-Codes (erweiterbar)
const VALID_ENTRY_CODES = ['friends', 'beta', 'press', 'dev'];

const STORAGE_KEY = 'randalaise_access';

/**
 * Prüft Zugang synchron beim ersten Laden
 */
function checkAccess() {
  // 1. Erst URL-Parameter prüfen
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search);
    const entryCode = params.get('entry');

    if (entryCode && VALID_ENTRY_CODES.includes(entryCode)) {
      // Code speichern
      localStorage.setItem(STORAGE_KEY, entryCode);
      return { hasAccess: true, entryCode };
    }
  }

  // 2. Dann localStorage prüfen
  if (typeof window !== 'undefined') {
    const storedCode = localStorage.getItem(STORAGE_KEY);
    if (storedCode && VALID_ENTRY_CODES.includes(storedCode)) {
      return { hasAccess: true, entryCode: storedCode };
    }
  }

  return { hasAccess: false, entryCode: null };
}

export function useAccessControl() {
  // Initialer Check (synchron)
  const [accessState] = useState(() => checkAccess());

  // URL bereinigen nach Mount (optional, ohne Redirect)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('entry') && accessState.hasAccess) {
      // URL bereinigen ohne Reload
      const url = new URL(window.location.href);
      url.searchParams.delete('entry');
      window.history.replaceState({}, '', url.pathname + url.search);
    }
  }, [accessState.hasAccess]);

  return accessState;
}

/**
 * Zugang widerrufen (für Testing/Logout)
 */
export function revokeAccess() {
  localStorage.removeItem(STORAGE_KEY);
}

/**
 * Prüft ob ein Code gültig ist (ohne zu speichern)
 */
export function isValidEntryCode(code) {
  return VALID_ENTRY_CODES.includes(code);
}
